// @ts-check

/**
 * Config conservateur par défaut (MVP)
 * Ajustable globalement (UI) et/ou par propriété (assumptions_json).
 */
export const defaultPortfolioConfig = {
    conservative: {
      ltvMaxRefi: 0.8,
      dscrMin: 1.2,
      vacancyRate: 0.05,
      capexReserveRate: 0.05,
      stressTestFloorRate: 5.25, // %
      stressTestBuffer: 2 // %
    },
    refi: {
      amortizationMode: "REMAINING", // 'REMAINING' | 'RESET'
      resetAmortizationYears: 25,
      autoRefiAtRenewal: false, // MVP: OFF (on affiche l'opportunité; refi auto = V2)
      cashOutMinToConsider: 10000
    }
  };
  